import React from 'react'

import { Tree, TreeNode } from "react-organizational-chart"
import _ from "lodash"
import clsx from "clsx"
import Card from "@material-ui/core/Card"
import CardContent from "@material-ui/core/CardContent"
import CardHeader from "@material-ui/core/CardHeader"
import Typography from "@material-ui/core/Typography"
import Box from "@material-ui/core/Box"
import IconButton from "@material-ui/core/IconButton"
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"
import { DndProvider } from "react-dnd"
import { HTML5Backend } from "react-dnd-html5-backend"

import {
    createTheme,
    makeStyles,
    ThemeProvider
} from "@material-ui/core/styles"

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    COLOR,
    paletaDireitoSucessorio,
} from '../../../business-const/Color/Color'

import {
    formataPerc,
} from '../../../business-components/Formata/Formata'

import {
    nomeCurtoFamiliar,
} from '../../../business-rules/String/nomeCurto'

import {
    GridContainer,
    GridItem5,
    GridItem6,
    GridItem7,
    GridItem10,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    CardGridDividerElementos,
} from '../../../business-components/Card/Card'

import {
    ChartPadraoPie
} from '../../../business-components/Chart/Chart'

import {
    dadosCompletosConjuge,
    tituloCliente,
    tituloConjuge,
} from '../cliente-form/ClienteService'

import {
    pesquisaDescricaoList,
} from '../../../business-rules/List/ListService'

import tipoRegimeBensList from '../../../business-rules/List/tipoRegimeBensList'

import {
    CardGridEstudoPadrao,
} from '../estudo-form/EstudoComp'


  
const GestaoPatrimonialFormEstruturaFamiliar = ( { values, report, clienteOuConjugeReport } ) => {
    
    const TreeEstruturaFamiliar = ({ clienteOuConjuge, clienteConjuge, filhos }) => {

        const useStyles = makeStyles((theme) => ({
            root: {
                background: "white",
                display: "inline-block",
                borderRadius: 16,
                margin: 5,
            },
            expand: {
                transform: "rotate(0deg)",
                marginTop: -10,
                marginLeft: "auto",
                transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.short
                })
            },
            expandOpen: {
                transform: "rotate(180deg)"
            },
            avatar: {
                backgroundColor: "#ECECF4"
            }
        }))

        function Organization({ org, onCollapse, collapsed }) {
            const classes = useStyles()

            const backgroundColor = org.account ? org.color : COLOR().corEstruturaFamiliar

            return (
                <Card
                    variant="outlined"
                    className={classes.root}
                    style={{ backgroundColor }}
                >
                    <CardHeader
                        className={(report ? '' : 'mt-2 ') + 'ml-2 mr-2'}
                        title={
                            <div
                                className={'font-light ' + (org.account ? report ? 'text-18' : 'text-36' : report ? 'text-26' : 'text-48')}
                            >
                                {org.tradingName}
                            </div>
                        }
                    />
                    
                    {!report && (
                        <IconButton
                            size="small"
                            onClick={onCollapse}
                            className={clsx(classes.expand, {[classes.expandOpen]: !collapsed})}
                        >
                            <ExpandMoreIcon />
                        </IconButton>
                    )}
                </Card>
            )
        }

        function Account({ a }) {
            const classes = useStyles()

            const backgroundColor = a.color

            return (
                <Card
                    variant="outlined"
                    className={classes.root}
                    style={{ backgroundColor }}
                >
                    <CardHeader
                        className={(report ? '' : 'mt-2 mb-2 ') + 'ml-2 mr-2'}
                        title={
                            <div
                                className={'font-light ' + (report ? values.familiares && values.familiares.length > 3 ? 'text-13' : 'text-18' : 'text-20')}
                            >
                                {a.name}
                            </div>
                        }
                    />
                </Card>
            )
        }

        function Product({ p }) {

            const classes = useStyles()

            return (
                <Card
                    variant="outlined"
                    className={classes.root}
                >
                    <CardContent>
                        <Typography
                            variant="subtitle2"
                            className={(report ? 'mb--2' : 'mt-2') + ' font-bold' + (report && values.familiares && values.familiares.length > 3 ? 'text-14' : 'text-16')}
                        >
                            {p.name}
                        </Typography>
                    </CardContent>
                </Card>
            )
        }

        function Node({ o, parent }) {
            const [collapsed, setCollapsed] = React.useState(o.collapsed)

            const handleCollapse = () => {
                setCollapsed(!collapsed);
            }

            React.useEffect(() => {
                o.collapsed = collapsed;
            })

            const T = parent
                ?
                    TreeNode
                :
                    (props) => (
                        <Tree
                            {...props}
                            lineWidth={"2px"}
                            lineColor={"#bbc"}
                            lineBorderRadius={"12px"}
                        >
                            {props.children}
                        </Tree>
                    )

            return collapsed
                ?
                    (
                        <T
                            label={
                                <Organization
                                    org={o}
                                    onCollapse={handleCollapse}
                                    collapsed={collapsed}
                                />
                            }
                        />
                    )
                : 
                    (
                        <T
                            className={report && values.familiares && values.familiares.length > 3 ? 'ml--7' : ''}
                            label={
                                <Organization
                                    org={o}
                                    onCollapse={handleCollapse}
                                    collapsed={collapsed}
                                />
                            }
                        >
                            {_.map(o.account, (a, i) => (
                                <TreeNode
                                    key={i}
                                    label={<Account a={a} />}
                                >
                                    <TreeNode
                                        label={<Product p={a.product} />}
                                    />
                                </TreeNode>
                            ))}

                            {_.map(o.organizationChildRelationship, (c, i) => (
                                <Node
                                    key={i}
                                    o={c}
                                    parent={o} 
                                />
                            ))}
                        </T>
            )
        }

        const theme = createTheme({
            palette: {
                //background: "white"
            },
            fontFamily: "Roboto, sans-serif"
        })

        const organizationChildRelationship = []
        
        if (values.possuiConjuge) {

            organizationChildRelationship.push(
                {
                    "tradingName": LABEL.meacao,
                    "account": clienteConjuge,
                    "color": COLOR().corMeacao,
                },
            )
        }

        if (values.familiares && values.familiares.length > 0) {
            organizationChildRelationship.push(
                {
                    "tradingName": LABEL.heranca,
                    "account": filhos,
                    "color": COLOR().corHeranca,
                }
            )
        }

        const organization = {
            "tradingName": LABEL.estruturaFamiliar +
                (
                    values.percHerancaFamiliarDiferenteConjuge
                        ?
                            ' ' +
                                (
                                    clienteOuConjuge === HARDCODE.idFamiliarCliente
                                        ?
                                            tituloCliente(values)
                                        :
                                            tituloConjuge(values)
                                )
                        :
                            ''
                ),
            "organizationChildRelationship": organizationChildRelationship
        }

        return (
            <ThemeProvider theme={theme}>
                <Box
                    bgcolor="background"
                    padding={4}
                >
                    <DndProvider
                        backend={HTML5Backend}
                    >
                        <Node
                            o={organization}
                        />
                    </DndProvider>
                </Box>
            </ThemeProvider>
        )
    }



    const DireitoSucessorio = ({ series, categorias }) => {

        return (
            <GridContainer>
                <GridItem12
                    align='center'
                >
                    {report
                        ?
                            <h2
                                className='mt-4'
                            >
                                {LABEL.direitoSucessorio}
                            </h2>
                        :
                            <h1
                                className='mt-4'
                            >
                                {LABEL.direitoSucessorio}
                            </h1>
                    }
                </GridItem12>

                <GridItem12
                    align='center'
                >
                    {report
                        ?
                            <h4
                                className='mb-4'
                            >
                                {(values.tipoRegimeBens ? pesquisaDescricaoList(tipoRegimeBensList, values.tipoRegimeBens) : '')}
                            </h4>
                        :
                            <h3
                                className='mb-4'
                            >
                                {(values.tipoRegimeBens ? pesquisaDescricaoList(tipoRegimeBensList, values.tipoRegimeBens) : '')}
                            </h3>
                    }
                </GridItem12>

                <GridItem12
                    ////align='center'
                    ////className={report ? '' : 'mb-12'}
                    className={report ? 'ml-50' : 'ml--10 mb-12'}
                    style={{height: values.tipoRegimeBens ? '441px' : '447px'}}
                >
                    <ChartPadraoPie
                        series={series}
                        width={report ? 480 : 500}////{report ? 280 : 480}
                        height={report ? 480 : 500}////{report ? 280 : 480}
                        labels={categorias}
                        paletaCores={paletaDireitoSucessorio}
                        fillType='gradient'
                        ////fillShadeIntensity={0.3}
                        ////notLegendShow={true}
                        seriePerc={true}
                    />
                </GridItem12>
            </GridContainer>
        )
    }

    const EstruturaFamiliar = ({ clienteOuConjuge}) => {

        ////const percMeacaoCliente = values.percMeacaoCliente// ? values.percMeacaoCliente : HARDCODE.percMeacaoDefault
        const percMeacaoCliente =
            clienteOuConjuge === HARDCODE.idFamiliarConjuge && values.percMeacaoCliente === 100
                ?
                    0
                :
                    values.percMeacaoCliente

        const clienteConjuge = [
            {
                "name": tituloCliente(values),
                "product": { "name": formataPerc(percMeacaoCliente, 0)},
                "color": COLOR().corMeacaoClienteConjuge,
            }
        ]

        let series = []
        let categorias = []


        if (dadosCompletosConjuge(values)) {
            //const nomeConjuge = tituloConjuge(values)
            const percMeacaoConjuge = 100 - percMeacaoCliente

            //const nomeClienteConjuge = clienteOuConjuge === HARDCODE.idFamiliarCliente ? nomeConjuge : tituloCliente(values)
            //const percMeacaoClienteConjuge = clienteOuConjuge === HARDCODE.idFamiliarCliente ? percMeacaoConjuge : percMeacaoCliente

            clienteConjuge.push(
                {
                    "name": tituloConjuge(values), //nomeConjuge,
                    "product": { "name": formataPerc(percMeacaoConjuge, 0)},
                    "color": COLOR().corMeacaoClienteConjuge,
                }
            )

            //if (percMeacaoCliente !== 100 && percMeacaoCliente !== 0) {

            //    series.push(
            //        percMeacaoClienteConjuge
            //    )

            //    categorias.push(
            //        nomeClienteConjuge
            //    )
            //}
        }

        let filhos = []

        let somaPercHerancaFamiliar = 0

        values.familiares?.forEach( (linhaFamiliares, indFamiliares) => {

            const percHerancaFamiliar =
                clienteOuConjuge === HARDCODE.idFamiliarCliente
                    ?
                        linhaFamiliares.percHerancaFamiliar
                    : 
                        linhaFamiliares.percHerancaFamiliarConjuge

            if (percHerancaFamiliar) {

                const nomeCurtoFamiliarAux = nomeCurtoFamiliar(linhaFamiliares)

                filhos.push(
                    {
                        "name": nomeCurtoFamiliarAux,
                        "product": { "name": formataPerc(percHerancaFamiliar, 0) },
                        "color": COLOR().corHerancaFamiliares,
                    },
                )

                series.push(
                    percHerancaFamiliar
                )

                somaPercHerancaFamiliar += percHerancaFamiliar

                categorias.push(
                    nomeCurtoFamiliarAux
                )
            }
        })

        if (values.possuiConjuge) {

            const percHeranca = 100 - somaPercHerancaFamiliar

            if (percMeacaoCliente === 100) {

                filhos = [
                    {
                        "name": tituloConjuge(values),
                        "product": { "name": formataPerc(percHeranca, 0) },
                        "color": COLOR().corHerancaFamiliares,
                    },
                    ...filhos
                ]

                series = [
                    percHeranca,
                    ...series
                ]

                categorias = [
                    tituloConjuge(values),
                    ...categorias
                ]
            }

            if (percMeacaoCliente === 0) {

                const percHeranca = 100 - somaPercHerancaFamiliar

                filhos = [
                    {
                        "name": tituloCliente(values),
                        "product": { "name": formataPerc(percHeranca, 0) },
                        "color": COLOR().corHerancaFamiliares,
                    },
                    ...filhos
                ]

                series = [
                    percHeranca,
                    ...series
                ]

                categorias = [
                    tituloCliente(values),
                    ...categorias
                ]
            }

            
            if (percMeacaoCliente !== 100 && percMeacaoCliente !== 0) {

                series.push(
                    percHeranca
                )

                categorias.push(
                    clienteOuConjuge === HARDCODE.idFamiliarCliente ? tituloConjuge(values) : tituloCliente(values)
                )
            }
        }
        
        return (
            <GridContainer
                className='justify-center'
            >
                <GridTree>
                    {report || values.modoApresentacao
                        ?
                            <div
                                className={report ? 'mt--3' : ''}
                            >
                                <TreeEstruturaFamiliar
                                    clienteOuConjuge={clienteOuConjuge}
                                    clienteConjuge={clienteConjuge}
                                    filhos={filhos}
                                />

                                <CardGridDividerElementos/>
                            </div>
                        :
                            <CardGridEstudoPadrao
                                label={''}
                                component={
                                    <GridContainer
                                        className='justify-center'
                                    >
                                        <TreeEstruturaFamiliar
                                            clienteOuConjuge={clienteOuConjuge}
                                            clienteConjuge={clienteConjuge}
                                            filhos={filhos}
                                        />
                                    </GridContainer>
                                }
                                overflowX={true}
                                popup={false}
                            />
                    }
                </GridTree>

                <GridGrafico>
                    {report || values.modoApresentacao
                        ?
                            <DireitoSucessorio
                                series={series}
                                categorias={categorias}
                            />
                        :
                            <CardGridEstudoPadrao
                                label={''}
                                component={
                                    <DireitoSucessorio
                                        series={series}
                                        categorias={categorias}
                                    />
                                }
                                overflowX={true}
                                popup={false}
                            />
                    }
                </GridGrafico>
            </GridContainer>
        )
    }


    const GridTree = values.modoApresentacao ? GridItem10 : (values.familiares && values.familiares.length > 2) || report ? GridItem12 : GridItem7 
    const GridGrafico = report || values.modoApresentacao ? GridItem12 : values.familiares && values.familiares.length > 2 ? GridItem6 : GridItem5



    return (
        <>
            {(!clienteOuConjugeReport || clienteOuConjugeReport === HARDCODE.idFamiliarCliente) && (
                <EstruturaFamiliar
                    clienteOuConjuge={HARDCODE.idFamiliarCliente}
                />
            )}

            {values.percHerancaFamiliarDiferenteConjuge &&
            (!clienteOuConjugeReport || clienteOuConjugeReport === HARDCODE.idFamiliarConjuge) && (
                <EstruturaFamiliar
                    clienteOuConjuge={HARDCODE.idFamiliarConjuge}
                />
            )}
        </>
    )
}

export default GestaoPatrimonialFormEstruturaFamiliar